<mifosx-entity-documents-tab [entityType]="entityType" [entityId]="entityId"
  [entityDocuments]="entityDocuments"
  [callbackUpload]="uploadDocument"
  [callbackDownload]="downloadDocument"
  [callbackDelete]="deleteDocument"
>
</mifosx-entity-documents-tab>
